import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Col,
  Layout,
  Select,
  Space,
  Tag,
  Radio
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyTwoTone,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import newDateTime from "controllers/newDateTime";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

function BugListManage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reRender, setReRender] = useState(false);

  const [rightBox, setRightBox] = useState([false, {}]);
  const [rightBoxPreNext, setRightBoxPreNext] = useState([false, false]);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [10, 50, 100, 200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 10, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
    filters: {
      status: "all",
    },
  });

  const rightFormRef = useRef(null);

  const columns = [
    {
      title: "NO",
      dataIndex: "rowKey",
      key: "rowKey",
      width: "100px",
    },
    {
      title: "처리상태",
      dataIndex: "status",
      key: "status",
      width: "100px",
      render:(_,record) => 
        _ === 10
        ? <Tag color="red">신고</Tag>
        : _ === 20
        ? <Tag color="blue">확인</Tag>
        : <Tag color="green">완료</Tag>
      
    },
    {
      title: "서브유닛",
      dataIndex: "ContentSubUnit_code",
      key: "ContentSubUnit_code",
      width: "150px",
    },
    {
      title: "문장번호",
      dataIndex: "ContentSentenceMaster_id",
      key: "ContentSentenceMaster_id",
      width: "100px",
    },
    {
      title: "영어문장",
      dataIndex: "sentence_text",
      key: "sentence_text",
      width: "300px",
    },
    {
      title: "신고일시",
      dataIndex: "create_datetime",
      key: "create_datetime",
      width: "200px"
    },
    {}
  ];

  const getSourceData = (data) => {
    // console.log(data)
    const total = data.data.data[1][0]["FOUND_ROWS()"];
    const page = tableParams.pagination.current
    const size = tableParams.pagination.pageSize
    const plusNum = (page-1) * size
    const sourceData = data.data.data[0].map((el,idx)=>{
        const nameArray = el.ContentSettingErrorTypeMaster_code.split(",").map(el=>{
          for(let i=0; i<data.data.data[2].length;i++) {
            if(data.data.data[2][i].code === el) {
              return data.data.data[2][i].name
            }
          }
        })
        
        const rowKey = total - idx -plusNum;
        el.name = nameArray
        el.create_datetime = newDateTime(el.create_datetime)
        el.rowKey = rowKey
        el.num = idx
        return el
    })
    // console.log(sourceData)

    setSourceDataKor(sourceData);

    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: total, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
    if(rightBox[0]) {
        setRightBox([true,sourceData[rowIndex]])
        rightFormRef.current.setFieldsValue(sourceData[rowIndex])
    }
  };

  const statusFilter = (value) => {
    // console.log(value)
    setRowIndex(null);
    setRightBox([false, {}]);
    setTableParams({
        ...tableParams,
        pagination:{...tableParams.pagination, current:1},
        filters:{
            ...tableParams.filters,
            status: value
        }
    })
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
        ...tableParams,
        pagination,
      });
      if (pagination.pageSize !== tableParams.pagination?.pageSize) {
        setSourceDataKor([]);
      }
      setRightBox([false,{}])
      setRowIndex(null)
  };

  // const copyToClipboard = () => { // https에서만 지원함
  //   const text = document.querySelector("#sentence").value
  //   window.navigator.clipboard.writeText(text)
  // }
  const copyToClipboard = () => {
      const text = document.querySelector("#sentence").value
      const tempElem = document.createElement('textarea');
      tempElem.value = text;  
      document.body.appendChild(tempElem);
    
      tempElem.select();
      document.execCommand("copy");
      document.body.removeChild(tempElem);

  }

  const onRow = (record, rowIdx) => {
    return {
      onClick: () => {
        const data = sourceDataKor;
        const maxNum = tableParams.pagination.total - 1;
        const plusNum =
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize;
        const idx = plusNum + rowIdx;

        if (data.length === 1) {
          setRightBoxPreNext([true, true]);
        } else if (idx === 0) {
          setRightBoxPreNext([true, false]);
        } else if (idx === maxNum) {
          setRightBoxPreNext([false, true]);
        } else {
          setRightBoxPreNext([false, false]);
        }
        setRowIndex(rowIdx);
        // setCurLanguage(data[idx].SystemSettingLanguage_code);
        setRightBox([true, data[rowIdx]]);
        if (rightBox[0]) {
          rightFormRef.current.setFieldsValue(data[rowIdx]);
        }
      },
    };
  };

  const resetValueRight = () => {
    const nowNum = rightFormRef.current.getFieldValue(["num"]);
    rightFormRef.current.setFieldsValue(sourceDataKor[nowNum]); // 리셋을 초기값으로 하지 않고 변경된 현재 데이터로 하기 위함
  };

  const editOkHandlerRight = async () => {

    try{
      let newData = rightFormRef.current.getFieldsValue()
     if(newData.status !== rightBox[1].status) {
    const saveRightRecord = await axios.post(
      `${backend}/contents/bug_manage/change`,
      {
        record:newData
      }
    )
    if (saveRightRecord.status === 200) {
        console.log(newData)
        if(tableParams.filters.status !== "all") {
        if(newData.rowKey === 1) { // sourceDataKor의 마지막 데이터인지?
            if(rowIndex === 0) { // 페이지의 맨 처음인지?
                if(tableParams.pagination.current === 1) {
                    setRightBox([false,{}])
                    setRowIndex(null)
                } else {
                    setRowIndex(tableParams.pagination.pageSize -1)
                    setTableParams({
                        ...tableParams,
                        pagination:{...tableParams.pagination,current:tableParams.pagination.current-1}
                    })
                }
            } else {
                setRowIndex(rowIndex -1)
            }
        }
        }
    setReRender(!reRender)
    }
    }
  } catch(err) {
    console.log("에러", err);
    Modal.error({
      title: "에러",
      okText: "확인",
      content: "서버에러가 발생하여 정상적으로 변경하지 못했습니다.",
      afterClose: () => {
        resetValueRight()
      },
    });
  }
  };

  const editCancelHandlerRight = () => {
    setRightBox([false, {}]);
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  };

  // // 이전 버튼 클릭 시 작동 함수
  const preRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setRightBoxPreNext([false, false]);
    }
    if (preNum === 0) {
      setRightBoxPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    // setCurLanguage(data[preNum].SystemSettingLanguage_code);

    if (rightBox[0]) {
      if (rowIndex === 0) {
        rightFormRef.current.setFieldValue("num", preNum - plusNum);
      } else {
        setRightBox([true, data[preNum - plusNum]]);
        rightFormRef.current.resetFields();
        rightFormRef.current.setFieldsValue(data[preNum - plusNum]);
      }
    }
  };

  // 다음 버튼 클릭 시 작동 함수
  const nextRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setRightBoxPreNext([false, false]);
    }
    if (nextNum === max) {
      setRightBoxPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);


    if (rightBox[0]) {
      if (nextNum - plusNum === 0) { //마지막 번호라서 다음 페이지로 넘어가야 할 때
        rightFormRef.current.setFieldValue("num", nextNum - plusNum);
      } else {
        setRightBox([true, data[nextNum - plusNum]]);
        rightFormRef.current.resetFields();
        rightFormRef.current.setFieldsValue(data[nextNum - plusNum]);
      }
    }
  };


  useEffect(() => {
    setLoading(true);
    const { current, pageSize } = tableParams.pagination;
    // console.log(tableParams)
    axios
      .post(`${backend}/contents/bug_manage/read?current=${current}&pageSize=${pageSize}`,
      {filter:tableParams.filters})
      .then((data) => {
        // console.log(data);
        getSourceData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, 
  [
    JSON.stringify(tableParams.filters),
    JSON.stringify(tableParams.pagination.current),
    JSON.stringify(tableParams.pagination.pageSize),
    reRender
  ]);

//   useEffect(() => {
//     if (rightBox[0]) {
//       const num = rightFormRef.current.getFieldValue("num");
//       rightFormRef.current.setFieldsValue(sourceDataKor[num]);
//     }
//   }, [sourceDataKor]);

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"100%", overflow: "auto" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ minWidth: "100px", textAlign: "left" }}>오류신고 목록</span>
        <Space wrap>
          <Select
            options={[{ value: "all", label: "처리상태: 전체" }, {value: 10, label:"신고"}, {value: 20, label:"확인"}, {value: 30, label:"완료"},]}
            style={{ width: 200, textAlign: "left" }}
            defaultValue="all"
            value={tableParams.filters.status}
            onChange={statusFilter}
          ></Select>
        </Space>
      </div>
      <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
       
        <Col flex={1} style={{ minWidth: "100px" }}>
          <StyledTable
            className="pageTable"
            onRow={onRow}
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            columns={columns}
            rowKey="id"
            dataSource={sourceDataKor}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            scroll={{ x:100, y:"100%"}}
          />
        </Col>

        {rightBox[0] ? (
          <Col
            flex={0}
            style={{
              minWidth: "500px",
              border: "1px whitesmoke solid",
              marginLeft: "10px",
              height: "100%",
              overflow:"auto"
            }}
          >
            <div
              style={{
                padding: "10px",
                borderBottom: "1px whitesmoke solid",
                fontWeight: 700,
                fontSize: 17,
                textAlign: "left",
              }}
            >
              오류신고내용
            </div>
            <Layout.Content style={{ padding: "10px" }}>
              <Form
                ref={rightFormRef}
                layout="vertical"
                initialValues={rightBox[1]}
              >
                <Form.Item name="id" label="id" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="rowKey" label="rowKey" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="num" label="num" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="ContentSentenceMaster_id" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="sentence_text" label="영어문장">
                  <Input
                    id="sentence"
                    disabled
                    suffix={<CopyTwoTone onClick={copyToClipboard} style={{cursor:"pointer"}}/>}
                  ></Input>
                </Form.Item>
                <Form.Item label="오류유형" style={{ textAlign: "left" }}>
                  {rightBox[1].name.map((el,idx)=>{
                    return <Tag key={idx}>{el}</Tag>
                  })}
                </Form.Item>
                <Form.Item name="opinion" label="기타의견">
                  <Input.TextArea autoSize disabled></Input.TextArea>
                </Form.Item>
                <Form.Item name="status" label="처리상태" style={{ textAlign: "left" }}>
                    <Radio.Group>
                        <Radio value={10}>신고</Radio>
                        <Radio value={20}>확인</Radio>
                        <Radio value={30}>완료</Radio>
                    </Radio.Group>
                </Form.Item>
              </Form>
            </Layout.Content>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                borderTop: "1px whitesmoke solid",
              }}
            >
              <Button onClick={resetValueRight}>내용 초기화</Button>
              <span>
                <Button
                  onClick={preRecordRight}
                  disabled={rightBoxPreNext[0] || loading}
                  icon={<LeftOutlined />}
                >
                  이전
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  type="primary"
                  onClick={editOkHandlerRight}
                  icon={<CheckOutlined />}
                >
                  수정
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={nextRecordRight}
                  disabled={rightBoxPreNext[1] || loading}
                  icon={<RightOutlined />}
                >
                  다음
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={editCancelHandlerRight}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          </Col>
        ) : null}

      </div>
    </div>
  );
}

export default BugListManage;
